import type React from 'react';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import * as st from './index.module.scss';

interface Props {
  quantity: string;
  price: number;
  partnerPrice: number;
}

const Price: React.FC<Props> = ({ price, partnerPrice, quantity }) => {
  const { permissions } = useModuleByCodeParam();
  const getProductPrice = (price: number, quantity: string): string => {
    const quantityParsed = parseInt(quantity);

    if (quantityParsed && !isNaN(quantityParsed)) {
      if (!permissions.can_sell) {
        return `${((price / 100) * quantityParsed).toLocaleString()}`;
      }

      return `${((partnerPrice / 100) * quantityParsed).toLocaleString()}`;
    }
    return `0`;
  };

  return (
    <div className={st.price}>
      <span className={st.price__title}>Стоимость</span>
      <div>
        <span className={st.price__main}>{getProductPrice(price, quantity)}</span>
        <span className={st.price__currentcy}>RUB</span>
      </div>
    </div>
  );
};

export default Price;
